// 第8张
const imgAll8 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642304166/a8.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642844292/c8.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642304166/a8.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642844292/c8.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725092257858/a8.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725092748651/b8.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725093141423/uk8.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725093604321/uk8.jpg',
    },
};
export const imgLocale8: any = {
    jp: imgAll8.JP,
    us: imgAll8.NA,
    ca: imgAll8.NA,
    br: imgAll8.NA,
    mx: imgAll8.NA,
    uk: imgAll8.UK,
    eu: imgAll8.EU,
    de: imgAll8.EU,
    fr: imgAll8.EU,
    it: imgAll8.EU,
    es: imgAll8.EU,
};
